namespace $.$$ {
	export class $bog_builderui_gallery extends $.$bog_builderui_gallery {}
}
